import {
  LOGIN_2FA_GENERAL_REQUEST,
  LOGIN_2FA_GENERAL_SUCCESS,
  LOGIN_2FA_GENERAL_FAILURE,
  GENERATE_LOGIN_2FA_SETUP_REQUEST,
  GENERATE_LOGIN_2FA_SETUP_SUCCESS,
  GENERATE_LOGIN_2FA_SETUP_FAILURE,
  CLEAR_LOGIN_2FA_SETUP,
} from '../../constants/ActionTypes';

const defaultData = () => {
  return {
    setupData: {},
    isFetching: false,
    error: {},
  };
};

const userLogin2fa = (
  state = {
    ...defaultData(),
  },
  action
) => {
  switch (action.type) {
    case GENERATE_LOGIN_2FA_SETUP_REQUEST:
      return { ...state, isFetching: true, error: {} };
    case GENERATE_LOGIN_2FA_SETUP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: {},
        setupData: action?.data?.data?.data,
      };
    case GENERATE_LOGIN_2FA_SETUP_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case CLEAR_LOGIN_2FA_SETUP:
      return { ...state, ...defaultData() };
    case LOGIN_2FA_GENERAL_REQUEST:
      return { ...state, isFetching: true, error: {} };
    case LOGIN_2FA_GENERAL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: {},
      };
    case LOGIN_2FA_GENERAL_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    default:
      return state;
  }
};

export default userLogin2fa;
